import { useCallback } from 'react';
import { useDownloadStateStore } from '../../store';
export const useDownloadProgress = (id) => {
    return useDownloadStateStore(useCallback(state => {
        return state.map[id.toString()]?.progress || 0;
    }, [id]));
};
//# sourceMappingURL=useDownloadProgress.js.map